import request from '@/utils/request.js'

/*****平台数据统计******/
export function getDataStatistics(){
    return request({
        url: 'agent/admin/count',
        method: 'get'
    })
}
/*****代理商数据汇总******/
export function getDataSummary(){
    return request({
        url: 'agent/count',
        method: 'get'
    })
}

/*****  代理商短信消耗top5  ******/
export function getSmsTopfive(){
    return request({
        url: 'agent/countMessage',
        method: 'get'
    })
}
export function getAgentAccount(data){
    return request({
        url: 'agent/account/list',
        method: 'post',
        data
    })
}

export function getAccountData(data){
    return request({
        url: 'agent/account/flow/list',
        method: 'post',
        data
    })
}

/*****  超级管理员短信消耗top5  ******/
export function getAdminSmsTopfive(){
    return request({
        url: 'agent/admin/countMessage',
        method: 'get'
    })
}

/*****  超级管理员每日短信消耗  ******/
export function getAdminEveDaySms(){
    return request({
        url: 'sim/messageDayCount',
        method: 'post'
    })
}

/*****  超级管理员每日流量消耗  ******/
export function getAdminEveDayFlow(){
    return request({
        url: 'sim/usedDayFlowCount',
        method: 'post'
    })
}